module.exports = __webpack_public_path__ + "img/img13@2x.0c5986f6.png";